/**
 * @file リーダーの「いまのページ」から、作品の問題を引く規則 (問題ごとの解説の設計 §6.1)。
 *
 * @what: 出題ページが今のページ以下である問題のうち最大のものを主とし、解答ページが今のページと
 *   一致する問題を併記する。ページは印刷ページで比べる (連番からの換算は呼び出し側)。
 * @why: 出題ページは節の途中に飛び飛びで並び、CHECK! の解答は別の場所にあるので、単純な一致では引けない。
 * @failure: 純関数である。該当が無ければ空配列である。
 */

import type { StudyWorkIndex, StudyWorkProblem } from "../api/studyWorks";

export interface ProblemsAtPage {
  /** 出題ページが今のページ以下で最大の問題 (同じページに複数あれば全部)。 */
  current: StudyWorkProblem[];
  /** 解答ページが今のページと一致する問題である。 */
  answered: StudyWorkProblem[];
}

export function problemsAtPage(index: StudyWorkIndex, printedPage: number): ProblemsAtPage {
  let best = -1;
  for (const p of index.problems) {
    if (p.page <= printedPage && p.page > best) best = p.page;
  }
  const current = best < 0 ? [] : index.problems.filter((p) => p.page === best);
  const answered = index.problems.filter((p) => p.answer_page === printedPage);
  return { current, answered };
}

/** ふりかえりの絞り込みに使う問題 id の集合 (主と併記を合わせる)。 */
export function problemIdsAtPage(index: StudyWorkIndex, printedPage: number): string[] {
  const { current, answered } = problemsAtPage(index, printedPage);
  return Array.from(new Set([...current, ...answered].map((p) => p.id)));
}
